import React from 'react';

import { L10nDate } from '@travel/i18n';

type Props = {
  value: string;
  locale?: string;
  dateFormat?: string;
  timeFormat?: string;
  className?: string;
  isDisplayAsLocalTime?: boolean;
};
const Date = (props: Props) => {
  return (
    <span className={props.className}>
      {props.dateFormat && <L10nDate {...props} format={props.dateFormat} />}
      {props.timeFormat && ' '}
      {props.timeFormat && <L10nDate {...props} format={props.timeFormat} />}
    </span>
  );
};

export default Date;
